import axios from 'axios'
import { apiUrl } from '@/config/api'

export const formatUpdateTime = () => {
  const now = new Date()
  const pad = (n) => `${n}`.padStart(2, '0')
  return `${pad(now.getMonth() + 1)}月${pad(now.getDate())}日 ${pad(now.getHours())}点${pad(now.getMinutes())}分`
}

export const fetchFundData = (tab, retryCount = 0) => {
  const maxRetries = 2

  return new Promise((resolve, reject) => {
    axios({
      url: apiUrl(`/miniprogram/market/data?tab=${tab}`),
      method: 'get',
      timeout: 15000
    })
      .then(response => {
        const payload = (response.data && response.data.data) || response.data || {}
        const columns = payload.columns || []
        const rawRows = payload.rows || []
        const updateTime = payload.updateTime || formatUpdateTime()

        const rows = rawRows.map((row) => {
          const cells = (columns || []).map((col) => {
            const type = col.type || 'text'
            if (type === 'fund') {
              return { type: 'fund', key: col.key }
            }
            if (type === 'premium') {
              return {
                type: 'premium',
                key: col.key,
                value: row.premium,
                className: `${col.className || ''} ${row.premiumClass || ''}`.trim()
              }
            }
            return {
              type,
              key: col.key,
              value: row[col.key],
              className: (col.className || '').trim()
            }
          })
          return { ...row, cells }
        })

        resolve({
          columns,
          rows,
          updateTime,
          tableTips: payload.tableTips || []
        })
      })
      .catch(error => {
        console.error('API请求失败:', error)
        if (retryCount < maxRetries) {
          setTimeout(() => {
            fetchFundData(tab, retryCount + 1)
              .then(resolve)
              .catch(reject)
          }, 1000 * (retryCount + 1))
        } else {
          resolve({
            columns: [],
            rows: [],
            updateTime: formatUpdateTime(),
            tableTips: []
          })
        }
      })
  })
}

export const fetchLofHistory = (code, fetchIfMissing = true) => {
  return axios({
    url: apiUrl('/miniprogram/market/lof/history'),
    method: 'get',
    params: { code, fetch: fetchIfMissing },
    timeout: 20000
  }).then((response) => {
    const body = response.data || {}
    if (body.code !== undefined && body.code !== 200) {
      return Promise.reject(new Error(body.msg || '获取历史数据失败'))
    }
    return body.data || body || {}
  })
}
